/**
 * Team prompt context — read for everyone, save for flow_library.manage.
 * For Media Devoted | Created By Ciro Autiero
 */

import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { fetchTeamContext, saveTeamContext } from '../client/ai-api';
import { libraryKeys } from '../keys';

export function useTeamContext() {
  return useQuery({
    queryKey: libraryKeys.teamContext(),
    queryFn: fetchTeamContext,
    staleTime: 60_000,
  });
}

export function useSaveTeamContext() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: saveTeamContext,
    onSuccess: (saved) => {
      queryClient.setQueryData(libraryKeys.teamContext(), saved);
    },
  });
}
